import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { toast } from "react-toastify";
import { getAPIUrlBM } from "../../../utils/config";
import Post from "../../../Apis/backlink/Post";
import { getWorkSpaceData } from "../../../store/actions/userData/WorkspaceData";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Modal, Typography } from "@mui/material";
import TipLoader from "../../utils/TipLoader/TipLoader";

export const SelectionBar = ({ data, unique, permanent, getData, setData }) => {
  const [selected, setSelected] = useState(setData ?? []);
  useEffect(() => {
    if (permanent) setSelected(data);
  }, [permanent]);

  useEffect(() => {
    if (getData) {
      getData(selected);
    }
  }, [selected, getData]);

  return (
    <div>
      {!permanent && (
        <div className="selection-heading">
          Dashboard (Select the one you want to give access to)
        </div>
      )}
      <div className="selection-icons">
        {data?.map((ele, index) => (
          <div
            style={{
              backgroundColor: selected.includes(ele.toString())
                ? "#828282"
                : "#fff",
              color: selected.includes(ele.toString()) ? "#fff" : "#828282",
            }}
            onClick={() => {
              if (!permanent) {
                if (selected.length && selected?.includes(ele.toString()))
                  setSelected((props) =>
                    props.filter((e) => e !== ele.toString()),
                  );
                else setSelected((props) => [...props, ele.toString()]);
              }
            }}
            className="selection-bar"
            key={unique + ele}
          >
            {ele}
          </div>
        ))}
      </div>
    </div>
  );
};

function ManageTeam() {
  const host = getAPIUrlBM();
  const emailRef = useRef();
  const dispatch = useDispatch();
  const [getData, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [tipLoader, setTipLoader] = useState(false);
  const [onCompleteLoad, setOnCompleteLoad] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  };
  //   const [initData, setInitData] = useState([]);
  const handler = async (email) => {
    try {
      toast.dismiss();
      if (!validateEmail(email)) {
        return toast.error("Email not valid");
      }
      if (getData.length === 0) {
        return toast.error("Roles cannot be empty");
      }
      setTipLoader(true);
      const response = await Post(host + "/createteams", {
        email,
        roles: getData,
      });
      console.log({ mTeamRes: response })
      setOnCompleteLoad(() => () => {
        if (response.status === 200) {
          toast.success(response.message);
          dispatch(getWorkSpaceData("backlink"));
          setData([]);
          handleOpen();
          emailRef.current.value = "";
        } else if (response.message) {
          toast.error(response.message);
        }
      })
      
    } catch (error) {
      console.log(error)
    }
    // console.log(response, "Team creating");
  };


  const deleteHandler = (email) => {
    window
      .sweet({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to see this user!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then(async (willDelete) => {
        if (willDelete) {
          const url = getAPIUrlBM();
          const res = await fetch(url + "/deleteUser", {
            method: "DELETE",

            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + localStorage.getItem("backlink_token"),
            },
            body: JSON.stringify({ email }),
          });
          if (res.status === 200) {
            dispatch(getWorkSpaceData("backlink"));
            window.sweet("Poof! Your  user has been deleted!", {
              icon: "success",
            });
          } else {
            window.sweet("Your user is safe!");
          }
        } else {
          window.sweet("Your user is safe!");
        }
      }).catch(err => {
        console.log(err)
      })
  };
 
  const editHandler = async () => {
    try {
      // edituserroles
      const url = getAPIUrlBM();
      const response = await Post(url + "/edituserroles", {
        email: edit.email,
        roles: editGetData,
      });
      if (response.status === 200) {
        setEdit({});
        dispatch(getWorkSpaceData("backlink"));
      }
      
    } catch (error) {
      console.log(error)
    }
  };
  const [edit, setEdit] = useState({});
  const [editGetData, setEditGetData] = useState([]);

  const { myUsers } = useSelector((data) => data.userData);
  return (
    <div>
      {tipLoader && <TipLoader onCompleteLoad={onCompleteLoad} setTipLoader={setTipLoader} />}
      <div className="invite">
        <div className="invite-heading">
          <div>Invite teammates</div>
          <div>Add or Remove team members.</div>
          <div>Give selective access to one or more dashboard.</div>
        </div>

        <div className="invite-section">
          <div className="invite-input">
            <div>Email</div>
            <input placeholder="example@doe.com" ref={emailRef} />
          </div>
          <div className="selection">
            <SelectionBar
              data={[
                "Domain",
                "Links",
                "Add Backlink",
                "Lists",
                "Create New List",
                "User Api Key",
                "Discover Backlinks",
              ]}
              unique={"selection_bar"}
              setData={getData}
              key={getData.length}
              getData={(temp) => setData(temp)}
            />
          </div>
          <div
            className="button_section"
            onClick={() => handler(emailRef.current.value)}
          >
            Add Teammate
          </div>
        </div>
      </div>

      <div className="currentTeammates">
        <table width={"100%"}>
          <tr
            style={{
              borderBottom: "1px solid #838383",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
            }}
          >
            <th
              style={{
                minWidth: "12%",
              }}
            >
              Name
            </th>
            <th
              style={{
                minWidth: "16%",
              }}
            >
              Status
            </th>
            <th
              style={{
                minWidth: "22%",
              }}
            >
              Email
            </th>

            <th
              style={{
                minWidth: "25%",
              }}
            >
              Dashboard
            </th>
            <th
              style={{
                minWidth: "25%",
              }}
            >
              Action
            </th>
          </tr>

          {myUsers.map((ele) => (
            <tr
              style={{
                display: "flex",
                textAlign: "center",
                padding: "1rem 0 0 0",
                alignItems: "center",
              }}
            >
              <td
                className=""
                style={{
                  minWidth: "12%",
                  textOverflow: "ellipsis",
                }}
              >
                {!ele.name && "..."}
                {ele.name}
              </td>

              <td
                className="name_hover_copy"
                style={{
                  minWidth: "16%",
                  textOverflow: "ellipsis",
                }}
              >
                {ele.name
                  ? "Active"
                  : (
                    window.location.origin +
                    "/accept-invitation/" +
                    localStorage.getItem("userid")
                  )
                    .toString()
                    .substring(0, 19)}
                {!ele.name && "..."}
                {!ele.name && (
                  <span
                    className="copy_link"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        window.location.origin +
                        "/backlink/accept-invitation/" +
                        localStorage.getItem("userid"),
                      );
                    }}
                  >
                    Copy Link
                  </span>
                )}
              </td>
              <td
                style={{
                  minWidth: "22%",
                  fontWeight: "400",
                  color: "#828282",
                }}
              >
                {ele.email}
              </td>
              <td
                style={{
                  minWidth: "25%",
                }}
              >
                <SelectionBar
                  data={ele.roles ?? []}
                  permanent
                  unique={"email"}
                />
              </td>
              <td
                style={{
                  minWidth: "25%",
                }}
              >
                <div className="current_buttons">
                  <div
                    onClick={() => {
                      setEdit(ele);
                      setEditGetData(ele.roles);
                    }}
                  >
                    <img
                      src="../icons/edit.svg"
                      width={12}
                      alt=""
                      style={{ marginRight: "2px" }}
                    />{" "}
                    Edit access
                  </div>
                  <div onClick={() => deleteHandler(ele.email)}>
                    {" "}
                    <img
                      src="../icons/remove.svg"
                      width={12}
                      alt=""
                      style={{ marginRight: "2px" }}
                    />
                    Remove access
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </table>
      </div>

      {edit.email && (
        <div
          className="container__popup"
          onClick={(e) => {
            const id = document.getElementById("inside__selector");
            if (!id.contains(e.target)) setEdit({});
          }}
        >
          <div id="inside__selector" className="container__selector">
            <img
              src="cross.svg"
              className="container__cross"
              alt=""
              onClick={() => setEdit({})}
            />
            <div className="container__title">
              Edit Permission for {edit.name}
            </div>
            <div className="container__drop">
              <SelectionBar
                data={[
                  "Domain",
                  "Links",
                  "Add Backlink",
                  "Lists",
                  "Create New List",
                  "User Api Key",
                  "Discover Backlinks",
                ]}
                setData={editGetData}
                key={editGetData.length + edit.email}
                getData={(temp) => setEditGetData(temp)}
              />
            </div>

            <div className="container__button">
              <button
                onClick={() => {
                  editHandler();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 4,
          }}
        >
          <div
            style={{
              position: "absolute",
              right: 20,
              top: 10,
              cursor: "pointer",
            }}
          >
            <img src="cross.svg" width={15} height={15} onClick={handleClose} />
          </div>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Please follow these steps to invite a user!
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <ol
              itemType="number"
              style={{
                padding: "0 1rem",
                color: "grey",
              }}
            >
              <li>Copy the link in the dashboard for that email ID.</li>
              <li>
                We will also send an email with steps in next 10 minutes. Please
                don't forget to check spam folder as well.
              </li>
              <li>Ask the invited user to login with that email</li>
              <li>Click on the Invite Link</li>
              <li>
                Once they accept the invite, they will see an option of
                switching the workspace in the top right
              </li>
            </ol>
          </Typography>
          <Typography
            sx={{
              color: "grey !important",
            }}
          >
            Every user has one workspace of which they are the owner. <br />
            They can be invited to multiple workspace. <br /> They will have to
            switch and work in your workspace to be able to work on your project
          </Typography>
          <div
            style={{
              display: "flex",
              paddingTop: "1rem",
            }}
          >
            <Button
              variant="contained"
              sx={{
                background: "#5541d7",
                margin: "auto",
                ":hover": {
                  background: "#5541d7",
                },
              }}
              onClick={() => {
                navigator.clipboard.writeText(
                  window.location.origin +
                  "/backlink/accept-invitation/" +
                  localStorage.getItem("userid"),
                );
              }}
            >
              Copy Link
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default ManageTeam;
